// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useCallback} from 'react';
import etask from '/util/etask.js';
import {Text_input} from '../../comp/text_input';
import * as api from '../../api.js';
import {alert} from '../../comp/alert';
import {Popup} from '../../comp/popup';
import store from '../../store.js';
import {Text} from '../../comp/text';
import './edit_device.less';

export function Edit_device({data, show, on_close}){
    const [name, set_name] = useState(data.title);
    const apply_name = useCallback(()=>etask(function*(){
        this.on('uncaught', console.error);
        let res;
        try {
            res = yield api.edit_device(data.uuid, {name});
        } catch(e){
            res = {error: e.message};
        }
        if (res.error)
        {
            alert({
                title: 'Error while editing device',
                text: res.error,
                negative: true,
            });
        }
        else
        {
            alert({text: 'Device successfully renamed', positive: true});
            store.use_devices.invalidate();
            store.use_usage.invalidate();
            on_close();
        }
    }), [name, data]);
    return <Popup title="Rename device" show={show} on_close={on_close}
      on_ok={apply_name}>
      <Text.s> Device ID:</Text.s>
      <Text.s tertiary className="ea_edit_device_label" mono>
        {data.uuid}
      </Text.s>
      <Text_input className="ea_edit_device_input" on_change={set_name}
        placeholder="Device name" value={name} autofocus/>
    </Popup>;
}
